module.exports={
  "editCutpoints": "Edit cutpoints",
  "numberOfClasses": "Number of classes",
  "classificationMethod": "Classification method",
  "insufficientBase": "Insufficient base",
  "categoryDefault": "Category (Default)",
  "equalInterval": "Equal interval",
  "arithmeticProgression": "Arithmetic Progression",
  "quantile": "Quantile",
  "naturalBreaksJenks": "Natural breaks (Jenks)",
  "custom": "Custom",
  "flipColors": "Flip colors",
  "projectPalettes": "Project palettes",
  "sequential": "Sequential",
  "diverging": "Diverging",
  "multi": "Multi",
  "createNewPalette": "Create new palette",
  "editColorPalette": "Edit color palette"
}
